import { Setup3APortfolioComponent } from './setup-3a-portfolio/setup-3a-portfolio.component';
import { SetupInvestmentComponent } from './setup-investment/setup-investment.component';
import { SetupPortfolioCompanyDetailComponent } from './setup-portfolio-company-detail/setup-portfolio-company-detail.component';
import { SetupPortfolioCompanyListComponent } from './setup-portfolio-company-list/setup-portfolio-company-list.component';
import { SetupPortfolioStocksBondsComponent } from './setup-portfolio-stocks-bonds/setup-portfolio-stocks-bonds.component';
import { SetupRisk3AComponent } from './setup-risk-3a/setup-risk-3a.component';
import { SetupRiskCHComponent } from './setup-risk-ch/setup-risk-ch.component';
import { SetupStrategyComponent } from './setup-strategy/setup-strategy.component';
import { SetupStrategyReviewComponent } from './setup-strategy-review/setup-strategy-review.component';
import { SetupTabsComponent } from './setup-strategy-tabs/setup-strategy-tabs.component';
import { Strategy3AComponent } from './strategy-3a/strategy-3a.component';
import { Strategy3APortfolioComponent } from './strategy-3a-portfolio/strategy-3a-portfolio.component';
import { Strategy3APortfolioEstimatedDevelopmentComponent } from './strategy-3a-portfolio-estimated-development/strategy-3a-portfolio-estimated-development.component';
import { Strategy3APortfolioFeesComponent } from './strategy-3a-portfolio-fees/strategy-3a-portfolio-fees.component';
import { Strategy3APortfolioSummaryComponent } from './strategy-3a-portfolio-summary/strategy-3a-portfolio-summary.component';
import { Strategy3ARiskComponent } from './strategy-3a-risk/strategy-3a-risk.component';
import { StrategyAdjustComponent } from './strategy-adjust/strategy-adjust.component';
import { StrategyCHComponent } from './strategy-ch/strategy-ch.component';
import { StrategyCHRiskComponent } from './strategy-ch-risk/strategy-ch-risk.component';
import { StrategyCompanyActionsComponent } from './strategy-company-actions/strategy-company-actions.component';
import { StrategyCompanyDetailComponent } from './strategy-company-detail/strategy-company-detail.component';
import { StrategyCompanyListComponent } from './strategy-company-list/strategy-company-list.component';
import { StrategyDonutChartComponent } from './strategy-donut-chart/strategy-donut-chart.component';
import { StrategyInterviewNotificationComponent } from './strategy-interview-notification/strategy-interview-notification.component';
import { StrategyInterviewWidgetComponent } from './strategy-interview-widget/strategy-interview-widget.component';
import { StrategyIntroComponent } from './strategy-intro/strategy-intro.component';
import { StrategyInvestmentComponent } from './strategy-investment/strategy-investment.component';
import { StrategyNotificationComponent } from './strategy-notification/strategy-notification.component';
import { StrategyPersonaliseComponent } from './strategy-personalise/strategy-personalise.component';
import { StrategyPortfolioComponent } from './strategy-portfolio/strategy-portfolio.component';
import { StrategyPortfolioCustomerSupportComponent } from './strategy-portfolio-customer-support/strategy-portfolio-customer-support.component';
import { StrategyPortfolioEstimatedDevelopmentComponent } from './strategy-portfolio-estimated-development/strategy-portfolio-estimated-development.component';
import { StrategyPortfolioFeesComponent } from './strategy-portfolio-fees/strategy-portfolio-fees.component';
import { StrategyPortfolioInyovaYellowComponent } from './strategy-portfolio-inyova-yellow/strategy-portfolio-inyova-yellow.component';
import { StrategyPortfolioStocksBondsComponent } from './strategy-portfolio-stocks-bonds/strategy-portfolio-stocks-bonds.component';
import { StrategyPortfolioSummaryMobileComponent } from './strategy-portfolio-summary/strategy-portfolio-summary-mobile.component';
import { StrategyPortfolioSummaryComponent } from './strategy-portfolio-summary/strategy-portfolio-summary.component';
import { StrategyPortfolioTopicsCriteriaComponent } from './strategy-portfolio-topics-criteria/strategy-portfolio-topics-criteria.component';
import { StrategyRiskRecheckComponent } from './strategy-risk-recheck/strategy-risk-recheck.component';
import { StrategyStackedAreaChartComponent } from './strategy-stacked-area-chart/strategy-stacked-area-chart.component';
import { StrategyStockAllocationComponent } from './strategy-stock-allocation/strategy-stock-allocation.component';
import { StrategyStockSplitSliderComponent } from './strategy-stock-split-slider/strategy-stock-split-slider.component';
import { StrategyTabsComponent } from './strategy-tabs/strategy-tabs.component';
import { StrategyTopicsComponent } from './strategy-topics/strategy-topics.component';
import { StrategyTopicsCardComponent } from './strategy-topics-card/strategy-topics-card.component';
import { StrategyWasChangedModalComponent } from './strategy-was-changed-modal/strategy-was-changed-modal.component';

export const components = [
  Strategy3AComponent,
  Strategy3APortfolioComponent,
  Strategy3APortfolioEstimatedDevelopmentComponent,
  Strategy3APortfolioFeesComponent,
  Strategy3APortfolioSummaryComponent,
  Strategy3ARiskComponent,
  StrategyAdjustComponent,
  StrategyCHComponent,
  StrategyCHRiskComponent,
  StrategyCompanyActionsComponent,
  StrategyCompanyDetailComponent,
  StrategyCompanyListComponent,
  StrategyDonutChartComponent,
  StrategyInvestmentComponent,
  StrategyIntroComponent,
  StrategyNotificationComponent,
  StrategyPersonaliseComponent,
  StrategyPortfolioComponent,
  StrategyPortfolioCustomerSupportComponent,
  StrategyPortfolioEstimatedDevelopmentComponent,
  StrategyPortfolioFeesComponent,
  StrategyPortfolioInyovaYellowComponent,
  StrategyPortfolioStocksBondsComponent,
  StrategyPortfolioSummaryComponent,
  StrategyPortfolioSummaryMobileComponent,
  StrategyPortfolioTopicsCriteriaComponent,
  StrategyRiskRecheckComponent,
  StrategyStackedAreaChartComponent,
  StrategyStockAllocationComponent,
  StrategyStockSplitSliderComponent,
  StrategyTabsComponent,
  StrategyTopicsCardComponent,
  StrategyTopicsComponent,
  StrategyWasChangedModalComponent,
  StrategyInterviewWidgetComponent,
  StrategyInterviewNotificationComponent,
  SetupTabsComponent,
  SetupStrategyComponent,
  SetupStrategyReviewComponent,
  SetupInvestmentComponent,
  SetupRiskCHComponent,
  SetupRisk3AComponent,
  SetupPortfolioStocksBondsComponent,
  SetupStrategyReviewComponent,
  SetupPortfolioCompanyListComponent,
  SetupPortfolioCompanyDetailComponent,
  Setup3APortfolioComponent
];

export * from './strategy-3a/strategy-3a.component';
export * from './strategy-3a-portfolio/strategy-3a-portfolio.component';
export * from './strategy-3a-portfolio-estimated-development/strategy-3a-portfolio-estimated-development.component';
export * from './strategy-3a-portfolio-fees/strategy-3a-portfolio-fees.component';
export * from './strategy-3a-portfolio-summary/strategy-3a-portfolio-summary.component';
export * from './strategy-3a-risk/strategy-3a-risk.component';
export * from './strategy-adjust/strategy-adjust.component';
export * from './strategy-ch/strategy-ch.component';
export * from './strategy-ch-risk/strategy-ch-risk.component';
export * from './strategy-company-actions/strategy-company-actions.component';
export * from './strategy-company-detail/strategy-company-detail.component';
export * from './strategy-company-list/strategy-company-list.component';
export * from './strategy-donut-chart/strategy-donut-chart.component';
export * from './strategy-investment/strategy-investment.component';
export * from './strategy-notification/strategy-notification.component';
export * from './strategy-personalise/strategy-personalise.component';
export * from './strategy-portfolio/strategy-portfolio.component';
export * from './strategy-portfolio-customer-support/strategy-portfolio-customer-support.component';
export * from './strategy-portfolio-estimated-development/strategy-portfolio-estimated-development.component';
export * from './strategy-portfolio-fees/strategy-portfolio-fees.component';
export * from './strategy-portfolio-inyova-yellow/strategy-portfolio-inyova-yellow.component';
export * from './strategy-portfolio-stocks-bonds/strategy-portfolio-stocks-bonds.component';
export * from './strategy-portfolio-summary/strategy-portfolio-summary.component';
export * from './strategy-portfolio-summary/strategy-portfolio-summary-mobile.component';
export * from './strategy-portfolio-topics-criteria/strategy-portfolio-topics-criteria.component';
export * from './strategy-risk-recheck/strategy-risk-recheck.component';
export * from './strategy-stacked-area-chart/strategy-stacked-area-chart.component';
export * from './strategy-stock-allocation/strategy-stock-allocation.component';
export * from './strategy-stock-split-slider/strategy-stock-split-slider.component';
export * from './strategy-tabs/strategy-tabs.component';
export * from './strategy-topics-card/strategy-topics-card.component';
export * from './strategy-topics/strategy-topics.component';
export * from './strategy-was-changed-modal/strategy-was-changed-modal.component';
export * from './strategy-interview-widget/strategy-interview-widget.component';
export * from './strategy-interview-notification/strategy-interview-notification.component';
export * from './setup-strategy-tabs/setup-strategy-tabs.component';
export * from './setup-strategy/setup-strategy.component';
export * from './setup-strategy-review/setup-strategy-review.component';
export * from './setup-investment/setup-investment.component';
export * from './setup-risk-ch/setup-risk-ch.component';
export * from './setup-risk-3a/setup-risk-3a.component';
export * from './setup-portfolio-stocks-bonds/setup-portfolio-stocks-bonds.component';
export * from './setup-portfolio-company-list/setup-portfolio-company-list.component';
export * from './setup-portfolio-company-detail/setup-portfolio-company-detail.component';
export * from './setup-3a-portfolio/setup-3a-portfolio.component';
